export class User {

	roles: string[];
	hasFullAccess: boolean;
	hasLoketAccess: boolean;
	hasWorkshopAccess: boolean;
}
